<template>
  <span class="other-ticket-ids" v-if="getOtherTicketIds(bet).length">
    <span class="open-dropdown" @click="toggleDropdown">
      <span class="text">
        {{ $t('BetSlip.MoreTicket') }}
      </span>
      <span
        class="arrow"
        :class="{
          opened: isOpened,
        }"
      >
        <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3.71448 0.10618L0.118095 3.37316C-0.0393657 3.51651 -0.0393657 3.74877 0.118095 3.89248C0.275556 4.03584 0.531313 4.03584 0.688774 3.89248L3.9998 0.884636L7.31083 3.89212C7.46829 4.03548 7.72405 4.03548 7.8819 3.89212C8.03937 3.74877 8.03937 3.51615 7.8819 3.3728L4.28556 0.105818C4.12972 -0.0353329 3.86995 -0.0353328 3.71448 0.10618Z"
            fill="#343A40"
          />
        </svg>
      </span>
    </span>

    <div class="dropdown-content" v-if="isOpened">
      <span v-for="item in getOtherTicketIds(bet)" :key="item">
        {{ item }}
      </span>
    </div>
  </span>
</template>

<script>
import snq from 'snq';

export default {
  name: 'BetTicketIdsArea',
  props: ['bet'],
  data() {
    return {
      isOpened: false,
    };
  },
  methods: {
    getTickets(bet) {
      let ids = [];
      let seperator = ',';
      const hasComma = snq(() => bet.TicketNumber.includes(','));
      const hasDel = snq(() => bet.TicketNumber.includes('|'));
      if (hasComma) {
        seperator = ',';
      }
      if (hasDel) {
        seperator = '|';
      }
      const parsed = bet.TicketNumber.split(seperator);
      parsed.forEach((p) => ids.push(p));
      return ids.filter(Boolean);
    },
    getOtherTicketIds(bet) {
      const [_, ...rest] = this.getTickets(bet);
      return rest;
    },
    toggleDropdown() {
      this.isOpened = !this.isOpened;
    },
  },
};
</script>
